<div class="page-content container">
  <div class="login shadow-sm">
    <div class="login-header">
      <!-- <span>Заборављена лозинка</span> -->
      <span>{{ translationManager.getTranslation('Заборављена лозинка') }}</span>
    </div>
    <div class="alert alert-info">
      <!-- <span><i class="fa fa-info-circle"></i>Молимо унесите валидно корисничко име за промену лозинке</span> -->
      <span><i
          class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Молимо унесите валидно корисничко име за промену лозинке') }}</span>
    </div>
    <div class="login-body">
      <div *ngIf="success">
        <div class="page-part">
          <!-- <div class="alert alert-success"><span><i class="fas fa-check"></i>Линк за промену лозинке је успешно послат на Вашу електронску пошту</span></div> -->
          <div class="alert alert-success"><span><i
                class="fas fa-check"></i>{{ translationManager.getTranslation('Линк за промену лозинке је успешно послат на Вашу електронску пошту') }}</span>
          </div>
        </div>
      </div>
      <div *ngIf="!success">
        <div class="page-part" *ngIf="error">
          <div class="alert alert-danger"><span><i class="fa fa-exclamation-triangle"></i>{{ error }}</span></div>
        </div>
        <div class="page-part">
          <div class="app-form-element"
            [ngClass]="{ 'app-form-element-error': form.elements['username'].error.required || form.elements['username'].error.invalid }">
            <!-- <label>Корисничко име</label> -->
            <label>{{ translationManager.getTranslation('Корисничко име') }}</label>

            <div class="app-form-element-content">
              <input type="text" name="username" [(ngModel)]="form.elements['username'].value" maxlength="250"
                (keyup.enter)="sendResetPassword()">
            </div>
            <div class="app-form-element-error-panel">
              <!--    <span *ngIf="form.elements['username'].error.required"><i class="fas fa-times-circle"></i>Поље је обавезно
                                за
                                унос</span> -->
              <span *ngIf="form.elements['username'].error.required"><i
                  class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>

            </div>
          </div>
        </div>
        <div class="app-form-element-buttons">
          <!-- <button class="btn btn-success" (click)="sendResetPassword()"><i class="fa fa-check mr-2"></i>Пошаљи захтев за ресетовање</button> -->
          <button class="btn btn-success" (click)="sendResetPassword()"><i
              class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Пошаљи захтев за ресетовање') }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
